import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Shield className="w-8 h-8 text-amber-500" />
              <div>
                <h3 className="font-heading text-xl font-bold">EMPIRE ROLLERZ</h3>
                <p className="text-xs text-amber-500 tracking-widest">SECURITY SOLUTIONS</p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Premium roller shutters and garage doors for commercial and residential properties. 
              Made to measure, delivered nationwide.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 text-amber-500">PRODUCTS</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products/commercial" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Commercial Shutters
                </Link>
              </li>
              <li>
                <Link to="/products/residential" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Residential Garage Doors
                </Link>
              </li>
              <li>
                <Link to="/products/shop" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Shop Front Shutters
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 text-amber-500">SERVICES</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Supply Only
                </Link>
              </li>
              <li>
                <Link to="/supply-installation" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Supply & Installation
                </Link>
              </li>
              <li>
                <Link to="/maintenance" className="text-slate-400 hover:text-white transition-colors text-sm">
                  Service & Maintenance
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4 text-amber-500">CONTACT</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-slate-400">
                <Phone className="w-4 h-4 text-amber-500" />
                <a href="tel:02084960499" className="hover:text-white transition-colors font-mono text-sm">
                  020 8496 0499
                </a>
              </li>
              <li className="flex items-center space-x-3 text-slate-400">
                <Mail className="w-4 h-4 text-amber-500" />
                <a href="mailto:info@empirerollerz.com" className="hover:text-white transition-colors text-sm">
                  info@empirerollerz.com
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400">
                <MapPin className="w-4 h-4 text-amber-500 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  Unit 3 Northgate Industrial Estate,<br />
                  Collier Row Road,<br />
                  Romford RM5 2BG
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Empire Rollerz. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm">
            <Link to="/blog" className="text-slate-400 hover:text-white transition-colors">
              Blog
            </Link>
            <Link to="/returns-policy" className="text-slate-400 hover:text-white transition-colors">
              Returns Policy
            </Link>
            <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
              Contact Us
            </Link>
            <Link to="/admin/login" className="text-slate-500 hover:text-amber-500 transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
